import { PUBLIC_CHAT_SESSION_ID_KEY } from './constants';

let memorySessionId: string | null = null;

function randomSessionId(): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  return `${Date.now()}-${Math.random().toString(36).slice(2, 14)}`;
}

function readStoredSessionId(): string | null {
  try {
    const v = localStorage.getItem(PUBLIC_CHAT_SESSION_ID_KEY);
    return v && v.trim() ? v.trim() : null;
  } catch {
    return null;
  }
}

/**
 * Returns the id used for API calls: existing from storage, or creates one on first send
 * (“chat initiated”) and persists until {@link clearPersistedChatSessionId}.
 */
export function ensureChatSessionId(): string {
  const fromStorage = readStoredSessionId();
  if (fromStorage) {
    memorySessionId = fromStorage;
    return fromStorage;
  }
  if (memorySessionId) return memorySessionId;
  const id = randomSessionId();
  try {
    localStorage.setItem(PUBLIC_CHAT_SESSION_ID_KEY, id);
    memorySessionId = id;
  } catch {
    memorySessionId = id;
  }
  return id;
}

/** Prefer server-issued id when the API returns one. */
export function adoptServerChatSessionId(sessionId: string): void {
  const t = sessionId.trim();
  if (!t) return;
  memorySessionId = t;
  try {
    localStorage.setItem(PUBLIC_CHAT_SESSION_ID_KEY, t);
  } catch {
    /* keep memorySessionId only */
  }
}

export function clearPersistedChatSessionId(): void {
  memorySessionId = null;
  try {
    localStorage.removeItem(PUBLIC_CHAT_SESSION_ID_KEY);
  } catch {
    /* private mode */
  }
}
